import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useDispatch } from 'react-redux'
import { ScrollableContainer } from 'web/components/generic/ScrollableContainer'
import { Sidebar } from 'web/components/shared/Sidebar'
import { useInputValue } from 'web/hooks/useInputValue'
import { AppActions, RenderMode } from 'web/redux/slices/app-slice'
import { DisplayFightActions } from 'web/redux/slices/display-fight-slice'
import { EditFightActions, useEditFightState } from 'web/redux/slices/edit-fight-slice'
import { EditSetupActions, useEditSetupState } from 'web/redux/slices/edit-setup-slice'
import { FightActions } from 'web/redux/slices/fight-slice'
import { SetupActions } from 'web/redux/slices/setup-slice'
import { isSetupFightEvent } from 'web/utils/type-utils'
import { assertDefined, assumeDefined, splitListByType } from 'web/utils/utils'
import { EditSetupComparisonContainer } from './EditSetupComparisonContainer'
import { EditSetupFightContainer } from './EditSetupFightContainer'
import { EditSetupSetupSidebar } from './EditSetupSidebar'

export const EditSetupMode: React.FC = () => {

    const fullFight = assumeDefined(useEditFightState(), 'fight')

    const { setup, comparisonActive } = useEditSetupState()
    assertDefined(setup)

    const disp = useDispatch()
    const [setupName, setSetupName, setSetupNameOnBlur] = useInputValue(setup.name)

    const endEdits = () => {
        disp(EditFightActions.endEdit())
        disp(EditSetupActions.endEdit())
    }

    const handleSaveEdits = () => {

        const { taken: setupFightEvents, remaining: fightEvents } = splitListByType(
            fullFight.events,
            isSetupFightEvent
        )

        disp(SetupActions.updateSetup({
            setup: {
                ...setup,
                name: setupName,
                setupFightEvents
            }
        }))

        disp(FightActions.updateFight({
            fight: fullFight.fight,
            segments: fullFight.segments,
            events: fightEvents
        }))

        endEdits()

        disp(AppActions.setRenderMode({ renderMode: RenderMode.Display }))
        disp(DisplayFightActions.selectSetup({ selectedSetupId: setup.id }))
    }

    const handleCancelEdits = () => {
        endEdits()
        disp(AppActions.setRenderMode({ renderMode: RenderMode.Display }))
    }

    return (
        <DndProvider backend={HTML5Backend}>
            <Sidebar sticky>
                <EditSetupSetupSidebar
                    fullFight={fullFight}
                    setup={setup}

                    setupNameInput={{
                        name: setupName,
                        setSetupName,
                        setSetupNameOnBlur
                    }}
                />
            </Sidebar>

            <ScrollableContainer>

                <div className="d-flex space-mx-3">
                    <EditSetupFightContainer
                        fullFight={fullFight}
                        setup={setup}

                        onSave={handleSaveEdits}
                        onCancel={handleCancelEdits}

                        comparisonActive={comparisonActive}
                    />

                    {comparisonActive &&
                        <EditSetupComparisonContainer />
                    }
                </div>

            </ScrollableContainer>
        </DndProvider>
    )
}
